<template>
  <v-banner single-line class="logged-in-as-banner">
    <v-icon slot="icon" color="warning" size="36">
      {{ icons.mdiAccountAlertOutline }}
    </v-icon>
    You are currently logged in as {{ testatorName }}

    <template #actions>
      <v-btn
        color="black"
        large
        depressed
        outlined
        rounded
        @click="logoutAsTestator()"
      >
        Logout
      </v-btn>
    </template>
  </v-banner>
</template>

<script>
  import { mdiAccountAlertOutline } from '@mdi/js';
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';
  import { logoutAsTestatorMixin } from '../../mixins/logout-as-testator';

  export default {
    name: 'LoggedInAsBanner',
    mixins: [logoutAsTestatorMixin],
    data() {
      return {
        testator: null,
        icons: {
          mdiAccountAlertOutline: mdiAccountAlertOutline,
        },
      };
    },
    computed: {
      testatorName() {
        if (this.testator) {
          return this.testator.fullName
            ? this.testator.fullName
            : this.testator.email;
        } else {
          return 'somebody else';
        }
      },
    },
    apollo: {
      testator: {
        query: TESTATOR_QUERY,
        variables() {
          return {
            id: this.testatorId,
          };
        },
        fetchPolicy: 'cache-only',
      },
    },
  };
</script>

<style lang="scss" scoped>
  .logged-in-as-banner {
    background-color: navajowhite !important;
  }
</style>
